module.exports = __webpack_public_path__ + "static/07-43eca4f109859a5e817997d86e9a011d.jpg";